import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useInfiniteQuery } from 'react-query';
const RecommendationLabelsForMatching = Object.keys(RecommendationLabel).filter(label => Number.isNaN(parseInt(label, 10)) &&
// Validate it's not an index
![RecommendationLabel.BEST_MATCH, RecommendationLabel.EXACT_MATCH, RecommendationLabel.GREAT_ALTERNATIVE, RecommendationLabel.UNKNOWN_LABEL].includes(label));
export const useMatchingLabels = function (recommendations, skipMatchingLabelsFetch) {
  var _infiniteResponse$dat;
  if (skipMatchingLabelsFetch === void 0) {
    skipMatchingLabelsFetch = false;
  }
  const {
    matchLabels
  } = DomainsApiClient.useQueries();
  const infiniteResponse = useInfiniteQuery({
    queryKey: ['matchLabels', recommendations.slice(0, 10)],
    getNextPageParam: lastPage => {
      var _lastPage$labels;
      return !!(lastPage != null && (_lastPage$labels = lastPage.labels) != null && _lastPage$labels.length);
    },
    enabled: recommendations.length > 0 && !skipMatchingLabelsFetch,
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
    refetchOnMount: false,
    queryFn: async () => {
      return matchLabels({
        domains: recommendations.slice(0, 10).map(_ref => {
          let {
            domain
          } = _ref;
          return domain;
        }).filter(domain => domain !== undefined),
        labels: RecommendationLabelsForMatching.slice(0, 10)
      });
    }
  });
  const labels = (infiniteResponse == null || (_infiniteResponse$dat = infiniteResponse.data) == null || (_infiniteResponse$dat = _infiniteResponse$dat.pages) == null ? void 0 : _infiniteResponse$dat.flatMap(page => {
    var _page$labels;
    return ((_page$labels = page.labels) == null ? void 0 : _page$labels.map(label => label)) ?? [];
  })) ?? [];
  return {
    fetchNextPage: infiniteResponse.fetchNextPage,
    hasNextPage: infiniteResponse.hasNextPage,
    isFetchingNextPage: infiniteResponse.isFetchingNextPage,
    isLoading: infiniteResponse.isLoading,
    labels
  };
};
//# sourceMappingURL=useMatchingLabels.js.map